import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import Main from "layouts/Main";
import Container from "components/Container";
import { Form } from "./components";

const PasswordRecover = () => {
  return (
    <Main>
      <Box
        position={"relative"}
        minHeight={"calc(100vh - 247px)"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        height={1}
      >
        <Container>
          <Grid container spacing={6}>
            <Grid
              item
              container
              alignItems={"center"}
              justifyContent={"center"}
              xs={12}
              md={6}
            >
              <Form />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Main>
  );
};

export default PasswordRecover;
